/**
 * CSRF-защита при токене сессии в куке (мини-ТЗ P9 §9, CAB-642).
 *
 * Double submit cookie: бэкенд продукта ставит куку {{eplex_csrf}} без {{HttpOnly}},
 * фронт на каждом изменяющем запросе кладёт то же значение в заголовок
 * {{X-CSRF-Token}}, бэкенд сверяет. Работает потому, что кросс-доменно атакующий
 * может заставить браузер ОТПРАВИТЬ куку, но не может её ПРОЧИТАТЬ.
 *
 * Токен выпускает бэкенд продукта, не REG: у каждого своя сессия, общий токен
 * означал бы, что утечка у одного открывает остальные.
 */

import { readCookie } from "./authBrowserState";

export const AUTH_CSRF_COOKIE = "eplex_csrf";
export const CSRF_HEADER = "X-CSRF-Token";

const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

export function isMutatingMethod(method: string | undefined): boolean {
  return MUTATING_METHODS.has((method ?? "get").toLowerCase());
}

/**
 * Значение читается в момент запроса, а не кэшируется при загрузке приложения.
 *
 * Причина: бэкенд молча обновляет пару токенов на обычном ответе (CAB-640), и
 * вместе с ней может обновиться CSRF-токен. Значение, прочитанное один раз на
 * старте, разъедется с кукой, и человек получит 403 в произвольный момент — без
 * всякой связи со своими действиями, то есть невоспроизводимо.
 */
export function readCsrfToken(): string | null {
  return readCookie(AUTH_CSRF_COOKIE);
}

/**
 * Заголовок для изменяющего запроса. Пустой объект, если куки нет: до перехода
 * бэкенда ЛК на единую авторизацию её не существует, и слать нечего.
 */
export function csrfHeader(method: string | undefined): Record<string, string> {
  if (!isMutatingMethod(method)) return {};

  const token = readCsrfToken();
  return token ? { [CSRF_HEADER]: token } : {};
}
